import Spinner from "../components/ui/Spinner"

/**
 * PageLoader - shown while a route's page code is downloading (Stage 2.3).
 *
 * Deliberately renders no Header/Sidebar: pages render their own AppShell, and mounting the shell
 * here would mount it twice (duplicate profile fetch and template bindings).
 */
export default function PageLoader() {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <Spinner size="lg" showLabel label="Loading page…" />
    </div>
  )
}
